import { InputDefinition } from '../../interface'

export const signUpFormDefinition: InputDefinition[] = [
  {
    id: 'username',
    inputType: 'text',
    name: 'username',
    label: 'Nazwa użytkownika',
    placeholder: 'Login',
    autoComplete: 'username'
  },
  {
    id: 'new-password',
    inputType: 'password',
    name: 'password',
    label: 'Hasło',
    placeholder: 'Hasło',
    autoComplete: 'new-password'
  },
  {
    id: 'confirm-new-password',
    inputType: 'password',
    name: 'passwordRepeated',
    label: 'Powtórz Hasło',
    placeholder: 'Powtórz Hasło',
    autoComplete: 'confirm-new-password'
  },
  {
    id: 'given-name',
    inputType: 'text',
    name: 'name',
    label: 'Imię',
    placeholder: 'Imię',
    autoComplete: 'given-name'
  },
  {
    id: 'family-name',
    inputType: 'text',
    name: 'surname',
    label: 'Nazwisko',
    placeholder: 'Nazwisko',
    autoComplete: 'family-name'
  },
  {
    id: 'email',
    inputType: 'text',
    name: 'email',
    label: 'Email',
    placeholder: 'Email',
    autoComplete: 'email'
  }
]
